import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";

export const CaseAuctionStatusType = union([
    literal("unknown"),
    literal("yes"),
    literal("no"),
]);
